import { render } from "./Table.vue?vue&type=template&id=39701a7a&scoped=true"
import script from "./Table.vue?vue&type=script&lang=ts"
export * from "./Table.vue?vue&type=script&lang=ts"

import "./Table.vue?vue&type=style&index=0&id=39701a7a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-39701a7a"

export default script